export default __webpack_public_path__ + "static/media/male_bowel-01.0c48c0ed.png";